// Shared asset technical specifications — used on the Digital Menu product page
// and in the Country Setup "Assets" step.
export const imageSpecs = [
  { type: "Popup Ad", format: "PDF, PNG, JPG, AI, EPS", resolution: "1080 × 1920 px", ratio: "9:16" },
  { type: "Banner / Slideshow", format: "PDF, PNG, JPG, AI, EPS", resolution: "1920 × 1080 px", ratio: "16:9" },
  { type: "Category Picture", format: "PDF, PNG, JPG, AI, EPS", resolution: "1920 × 1080 px", ratio: "16:9" },
  { type: "Product Picture", format: "PDF, PNG, JPG, AI, EPS", resolution: "High quality", ratio: "Simple bg" },
  { type: "Product Video", format: "MOV, MP4", resolution: "High quality", ratio: "16:9" },
];

export const specsPdf = "/images-video-instructions.pdf";
